export const company = {
  name: 'Lifetime Creation Construction and Manufacturing Company Limited',
  shortName: 'Lifetime Creation',
  tagline: 'Building Solutions That Stand the Test of Time',
  founder: 'Damian Cummings',
  foundedYear: 2016,
  location: 'Jamaica',
  coverage: 'Islandwide Jamaica',
  safetyStandard: 'OSHA 29 CFR 1926',

  mission:
    'To deliver high-quality construction and manufacturing services that exceed client expectations through integrity, innovation, and technical excellence.',

  vision:
    'To become a trusted leader in construction and manufacturing across Jamaica, recognized for durability, efficiency, and long-term value creation.',

  description:
    'Lifetime Creation Construction and Manufacturing Company Limited is a Jamaican-based construction company committed to delivering durable, high-quality, and cost-effective building solutions. We combine practical construction expertise with manufacturing precision to provide clients with reliable results that stand the test of time. Our team brings strong technical knowledge, hands-on experience, and a commitment to excellence across residential, commercial, civil and industrial projects. From foundation to final completion, we focus on structural integrity, efficiency, and professional project execution.',
};

export const targetClients = [
  {
    title: 'Low Income',
    description:
      'Affordable housing solutions with essential quality standards, helping families achieve homeownership within their means.',
    icon: 'Wallet',
  },
  {
    title: 'Middle Income',
    description:
      'Quality construction solutions tailored to meet your budget without compromising on durability or craftsmanship.',
    icon: 'Home',
  },
  {
    title: 'High Income',
    description:
      'Premium building services with superior materials and finishes for discerning clients who demand excellence.',
    icon: 'Building2',
  },
  {
    title: 'International Investors',
    description:
      'Trusted construction partner for overseas real estate investments with transparent project management and communication.',
    icon: 'Globe',
  },
];

export const whyChooseUs = [
  {
    title: 'Integrated Construction and Manufacturing Expertise',
    description:
      'Our combined construction and manufacturing capabilities ensure seamless project execution and quality control.',
    icon: 'Cog',
  },
  {
    title: 'Skilled Workforce and Quality Craftsmanship',
    description:
      'Experienced tradesmen and professionals dedicated to delivering superior workmanship on every project.',
    icon: 'Users',
  },
  {
    title: 'On-Time and On-Budget Delivery',
    description:
      'Disciplined project management ensures your project is completed within agreed timelines and budget.',
    icon: 'Clock',
  },
  {
    title: 'Strong Focus on Structural Durability',
    description:
      'We build structures designed to withstand Jamaica\'s climate and stand the test of time.',
    icon: 'Shield',
  },
  {
    title: 'Client-Centered Project Approach',
    description:
      'Your vision and requirements guide every decision, with transparent communication throughout.',
    icon: 'Heart',
  },
];

export const processSteps = [
  {
    step: 1,
    title: 'Consultation',
    description: 'We discuss your project vision, requirements, and budget to understand your goals.',
    icon: 'MessageSquare',
  },
  {
    step: 2,
    title: 'Site Assessment',
    description: 'Our team evaluates the site conditions, access, and any technical considerations.',
    icon: 'MapPin',
  },
  {
    step: 3,
    title: 'Planning',
    description: 'Detailed project plans, timelines, and cost estimates are developed for your approval.',
    icon: 'ClipboardList',
  },
  {
    step: 4,
    title: 'Approvals',
    description: 'We assist with obtaining necessary permits and regulatory approvals.',
    icon: 'FileCheck',
  },
  {
    step: 5,
    title: 'Construction',
    description: 'Expert execution with regular progress updates and quality control checkpoints.',
    icon: 'HardHat',
  },
  {
    step: 6,
    title: 'Handover',
    description: 'Final inspection, documentation, and smooth handover of your completed project.',
    icon: 'Key',
  },
];
